declare let THREE: any;

export class RectForPicket extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));

  public static readonly Name = 'RectForPicket';

  constructor(size: number, texture) {
    const geometry = new THREE.PlaneBufferGeometry(size, size).applyMatrix(RectForPicket.rotationTransform);
    const material = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      map: texture,
      transparent: true,
      opacity: 0.01
    });
    material.map.center.set(0.5, 0.5);
    super(geometry, material);
    this.name = RectForPicket.Name;
  }

  updateTextureRotation(parent) {
    this.material.map.rotation = -parent.rotation.y;
    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/RectForPicket.ts